module.exports = __webpack_public_path__ + "static/media/appQuizHover.7bc97efc.svg";